import { SUBDIVISION_NAMES } from './subdivisionNames.generated';

/**
 * Human-readable name for an ISO 3166-2 subdivision code.
 *
 * Sourced from a CLDR-derived map (see `subdivisionNames.generated.ts`), which
 * is the authoritative, current Unicode dataset. Falls back to the raw code when
 * CLDR has no name for it (the cosmetic long-tail of ~4% of codes) so the picker
 * never renders blank. Used to humanize the backend-driven location state picker.
 */
export function getSubdivisionName(
  country: string | null | undefined,
  code: string | null | undefined
): string {
  if (!code) return '';
  if (!country) return code;
  return SUBDIVISION_NAMES[`${country}-${code}`] ?? code;
}
